import { createTheme } from '@mui/material/styles';

export const DefaultTheme = createTheme({
  palette: {
    primary: {
      main: '#52418a',
    },
    secondary: {
      main: '#000000',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
    fontFamily: 'Lato,sans-serif',
  },
});
